import { Component, OnInit } from '@angular/core';
import * as moment from 'moment';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { UserService } from 'src/app/core/services/user.service';
import { Subscription } from 'rxjs';
import { CommanSubscribeService } from 'src/app/core/services/comman-subscribe.service';
import { Router } from '@angular/router';
import { UtilityService } from 'src/app/core/services/utility.service';
import { LandingPageService } from 'src/app/core/services/landing-page.service';
export type OrganizationInfo = {
  id: number;
  business_as_name: string;
  organization_name: string;
  organization_logo: string;
  organization_banner: string;
  channel_banner: string;
  contactName: string;
  bEmail: string;
  channel_logo: string;
  organization_key: string;
  channel_name: string;
}
@Component({
  selector: 'app-communities',
  templateUrl: './communities.component.html',
  styleUrls: ['./communities.component.scss']
})
export class CommunitiesComponent implements OnInit {
  bannerList = []
  isLoadingEvent: boolean;
  eventList: any = {};
  timezoneVal;
  myListResp: any;
  myListInfoSubscription: Subscription;
  userInfoSubscription: Subscription;
  searchfil: any;
  userInfo: any = {};
  myList: any = [];
  FilterDrop = ['Live', 'Upcoming'];
  SortDrop = [{
    name: 'Organisation Name (A-Z)',
    value: "a-z"
  }, {
    name: 'Organisation Name (Z-A)',
    value: "z-a"
  }, {
    name: 'Organisation Date (Ascending)',
    value: "latest"
  }, {
    name: 'Organisation Date (Descending)',
    value: "oldest"
  }];

  dumarray = []
  merchandiseOrganizations: any;
  allOrgFeatures: any[];
  constructor(private ngxLoader: NgxUiLoaderService, private utilityService: UtilityService,
    private http: HttpClient, private userService: UserService, private commanService: CommanSubscribeService, private router: Router, private landingPageService: LandingPageService,) { }

  ngOnInit() {
    this.getList()
    // this.timezoneVal = this.userService.getTimezone();
    this.userInfo = this.commanService.userInfo;
    this.userInfoSubscription = this.commanService.getUserInfo().subscribe(response => {
      this.userInfo = response;
    });
    console.log(this.userInfo, "userinfo")
    // if (this.userInfo.id) {
    //   this.getList();
    // }
  }

  async getList() {
    this.ngxLoader.start();
    this.http.get<any>(environment.API_URL_COMMUNITY, { observe: 'response' }).subscribe({
      next: async (response) => {
        if (response.body && response.body.status === 0) {
          this.allOrgFeatures = await this.utilityService.loadAllOrganizationFeaturesByFeature("community");
          this.merchandiseOrganizations = this.allOrgFeatures
            .filter((org: any) => org.dataStatus === "A")
            .map((org: any) => org.orgId);
          this.bannerList = response.body.result.filter((org: any) =>
            this.merchandiseOrganizations.includes(org.id))
        }
        this.ngxLoader.stop();
      },
      error: (error) => {
        console.error('API Error:', error);
        this.ngxLoader.stop();
      },
      complete: () => {
        console.log('Request complete');
      }
    });


  }

  formatDate(startDate, endDate) {
    let startMonth = moment.utc(startDate, "YYYY-MM-DD HH:mm:ss").tz(this.timezoneVal).format('MMM')
    let endMonth = moment.utc(endDate, "YYYY-MM-DD HH:mm:ss").tz(this.timezoneVal).format('MMM')
    console.log(startMonth, endMonth)
    let formattedStartDate = moment.utc(startDate, "YYYY-MM-DD HH:mm:ss").tz(this.timezoneVal).format('D')
    let formattedEndDate = moment.utc(endDate, "YYYY-MM-DD HH:mm:ss").tz(this.timezoneVal).format('D')
    if (startMonth === endMonth && formattedStartDate == formattedEndDate) {
      return `${startMonth} ${formattedStartDate}`
    } else if (startMonth == endMonth && formattedStartDate != formattedEndDate) {
      return `${startMonth} ${formattedStartDate}-${formattedEndDate}`
    } else {
      return `${startMonth} ${formattedStartDate}- ${endMonth} ${formattedEndDate}`
    }
  }

  goToChannels(event, item: OrganizationInfo) {
    const userId = this.userInfo?.user_first_name + ' ' + this.userInfo?.user_last_name;
    
    (window as any).umami?.track(`Channel ${item.id} clicked - ${userId}`);
    const u_payload = {
      actionType: "community",
      metaData: {
        title: `Channel ${item.id} clicked`,
        timeStamp: new Date().toISOString()
        
      },
      organizationId: this.commanService?.slugInfo?.organization_id || null,

      clickAction: `community`
    }
    this.commanService.sendTriggeredEvent(u_payload);
    if (this.userInfo.id) {
      this.commanService.sendOrganizationData(item);
      this.router.navigateByUrl(`/${item.channel_name}/community`);

    }else {
      this.landingPageService.openConsumerSignIn(item);
    }

  }

  filterValue = "";
  categoryList = []
  selectedCat = "";
  selectedCatIndex: any;
  sortValue = ""
  sortEvent = {}

  sortData(event) {
    if (event) {
      this.sortEvent = event;
    }
    let data = event.value;
    this.sortValue = event.name;
    this.bannerList.forEach(dat => {
      console.log(dat, "dat")
    })
    if (data == "a-z") {
      this.bannerList = this.bannerList.sort((a, b) => a.organization_name.toLowerCase() > b.organization_name.toLowerCase() ? 1 : -1);
    }
    else if (data == 'z-a') {
      this.bannerList = this.bannerList.sort((a, b) => a.organization_name.toLowerCase() > b.organization_name.toLowerCase() ? -1 : 1);
    }
    else if (data == "latest") {
      this.bannerList = this.bannerList.sort((a, b) => Date.parse(a.created_on) - Date.parse(b.created_on))
    }
    else if (data == "oldest") {
      this.bannerList = this.bannerList.sort((a, b) => Date.parse(b.created_on) - Date.parse(a.created_on))
    }
  }
}
